import { useNavigate, useLocation } from "react-router-dom"

const useHandlePageGoTo = () => {
    const navigate = useNavigate()
    const handlePageGoTo = (route) => {
        if (route.startsWith('http')) {
            window.open(route, "_blank")
        } else {
            navigate(route)
        }
    }
    return handlePageGoTo
}

// TODO improvements?
const useIsHidden = () => {
    const location = useLocation()
    const currentPage = location.pathname.split("/")[1]
    const hidden = ["login", "sign-up", "initializing", "set-up", "verify", "verify-error", "forgot-password"].includes(currentPage)
    return hidden
}

// TODO improvements?
const useIsLoginButtonsHidden = () => {
    const location = useLocation()
    const path1 = location.pathname.split("/")[1]
    const path2 = location.pathname.split("/")[2]
    const path1Match = path1 == "ap"
    const path2Match = ["vendor", "invoice"].includes(path2)
    return path1Match || path2Match
}

export { useHandlePageGoTo, useIsHidden, useIsLoginButtonsHidden }
